import { ReactNode } from 'react';
import { Alert, AlertProps } from 'reactstrap';

import './AlertStyle.scss';

interface CustomAlertProps extends AlertProps {
  children: string | ReactNode
}
function CustomAlert({ children, ...props }: CustomAlertProps) {
  return (
    <Alert className="custom-alert-error" id="custom-alert" {...props}>
      {children}
    </Alert>
  );
}

export default CustomAlert;
